import React from 'react';

const MetricsCardSkeleton = ({ delay = 0 }) => {
  return (
    <div 
      className="card p-4 animate-pulse"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          {/* Title */}
          <div className="h-4 w-24 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-1"></div>
          
          {/* Value */}
          <div className="h-8 w-16 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-1"></div>
          
          {/* Subtitle */}
          <div className="h-3 w-20 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>
        
        {/* Icon Container */}
        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-gray-200 to-gray-300 flex-shrink-0"></div>
      </div>
      
      {/* Trend Section */}
      <div className="flex items-center mt-3 pt-3 border-t border-border">
        {/* Trend Icon */}
        <div className="w-4 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        
        {/* Trend Value */}
        <div className="h-4 w-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded ml-1"></div>
        
        {/* Trend Text */}
        <div className="h-4 w-20 bg-gradient-to-r from-gray-200 to-gray-300 rounded ml-1"></div>
      </div>
    </div>
  );
};

export default MetricsCardSkeleton;
